import styled from 'styled-components';
import { Spinner } from '../../../util/spinner.tsx';
import { useHuddleGitHubTopTen } from './use_huddle.ts';

// The huddle's "top 10" section.  It fetches independently of the prayer focus cards, so GitHub
// being slow, down or unconfigured never keeps the cards from rendering.  A missing API token is
// the expected state until the PAT is issued, and reads as an informational absence, not an error.
export const GitHubIssuesTable = () => {
  const { topTen, isLoading, error } = useHuddleGitHubTopTen();

  return (
    <Section>
      <Heading>Top 10 issues</Heading>
      {isLoading && <Spinner />}
      {!isLoading && error && <Notice>GitHub issues unavailable: {error}</Notice>}
      {!isLoading && !error && topTen && (
        <>
          {topTen.notice && <Notice>{topTen.notice}</Notice>}
          {topTen.issues.length === 0 && !topTen.notice && <Notice>No open issues labelled top-10.</Notice>}
          {topTen.issues.length > 0 && (
            <Table>
              <tbody>
                {topTen.issues.map((issue) => (
                  <Row key={issue.number}>
                    <NumberCell>
                      <IssueLink href={issue.url} target="_blank" rel="noreferrer">
                        #{issue.number}
                      </IssueLink>
                    </NumberCell>
                    <TitleCell>
                      <IssueLink href={issue.url} target="_blank" rel="noreferrer">
                        {issue.title}
                      </IssueLink>
                    </TitleCell>
                    <LabelCell>
                      {issue.labels.map((label) => (
                        <Label key={label}>{label}</Label>
                      ))}
                    </LabelCell>
                  </Row>
                ))}
              </tbody>
            </Table>
          )}
        </>
      )}
    </Section>
  );
};

const Section = styled.div`
  margin-top: 32px;
  text-align: left;
  max-width: 900px;
`;

const Heading = styled.h2`
  text-align: left;
  margin: 0 0 8px;
  font-size: 1.3rem;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const Row = styled.tr`
  border-bottom: 1px solid var(--color-hairline);
`;

const Cell = styled.td`
  padding: 6px 8px 6px 0;
  vertical-align: top;
`;

const NumberCell = styled(Cell)`
  white-space: nowrap;
  color: var(--color-text-darker);
  width: 1%;
`;

const TitleCell = styled(Cell)`
  width: 99%;
`;

const LabelCell = styled(Cell)`
  white-space: nowrap;
`;

const IssueLink = styled.a`
  color: var(--color-link);
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const Label = styled.span`
  display: inline-block;
  margin-left: 6px;
  padding: 1px 8px;
  border: 1px solid var(--color-hairline);
  border-radius: 10px;
  font-size: 0.8rem;
  color: var(--color-text-darker);
`;

const Notice = styled.div`
  color: var(--color-text-lighter);
  font-style: italic;
`;
